import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
function SearchTable(props) {
    let months= ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
  let [result, setResult] = useState(props.result);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [modalMapper, setModalMapper] = useState(props.modalMapper);
  const [searchString, setSearchString] = useState(props.searchString);
  const [currentPage, setCurrentPage] = useState(0);
  const isFirstPage = currentPage === 0;
  let [allResults, setAllResults] = useState(props.allResults);
    let [render,setRender]=useState(true)
  let lt = 150;
  const [end, setEnd] = useState(pageSize);
  const [sort,setSort]=useState('')
  const [sortDate,setSortDate]=useState('')
  const highlightText = (text) => {
    if (!text || searchString.trim() === "") {
      return text;
    }

    const regex = new RegExp(`(${searchString})`, "gi");
    const parts = text.toString().split(regex);

    return parts.map((part, index) => {
      if (regex.test(part)) {
        return <mark key={index}>{part}</mark>;
      }
      return part;
    });
  };
  const modalFunction = (modalProjectId) => {
    let ch = (
      <div
        id="modal"
        className="relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
        <div id='scroll1' class="fixed inset-0 z-10 overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[50rem] break-words">
              <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 relative">
                <button
                  className="absolute -top-2 -right-2 border border-solid border-red-800"
                  onClick={() => {
                    const root = ReactDOM.createRoot(
                      document.getElementById("modalDisplay")
                    );
                    root.render(<></>);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#e94e52"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    className="w-8 h-8 text-white font-extrabold absolute top-2 right-2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </button>
                <div class="sm:flex sm:items-start">
                  <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6 text-blue-500"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                      />
                    </svg>
                  </div>
                  <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <h3
                      class="font-semibold leading-6 text-base text-gray-700 "
                      id="modal-title"
                    >
                      Task Details
                    </h3>
                    
                    <div id='scroll2' className="max-h-[50vh] overflow-auto">
                      <table className="mt-2 mr-4">
                        <thead className="bg-zinc-200 font-bold text-sm">
                          <tr>
                            <td className="px-2 py-2">Srl No.</td>
                            <td className="px-2 py-2">Task Description</td>
                            <td className="px-2 py-2">Task Name</td>
                            <td className="px-2 py-2">Time Tracked(hr)</td>
                          </tr>
                        </thead>
                        <tbody className=" text-slate-700 text-sm">
                          {modalMapper[modalProjectId]
                            ? modalMapper[modalProjectId].map((it, index) => (
                                <tr>
                                  <td className="text-center">{index + 1}</td>
                                  <td className="max-w-[20rem]">
                                    <div className="max-w-[100%] inline-block overflow-y-auto break-words overflow-x-hidden max-h-[100px]">
                                      {highlightText(it.TaskDescription)}
                                    </div>
                                  </td>
                                  <td className="max-w-[10rem]">
                                    <div className="max-w-[100%] inline-block overflow-y-auto break-words overflow-x-hidden max-h-[100px]">
                                      {highlightText(it.TaskName)}
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    {it.HoursTracked
                                      ? it.HoursTracked.toFixed(2)
                                      : ""}
                                  </td>
                                </tr>
                              ))
                            : ""}
                          <tr></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    const root = ReactDOM.createRoot(document.getElementById("modalDisplay"));
    root.render(ch);
  };
  let dateSort=(type)=>{
    if (type == "ascending") {
      for (let i = 0; i < result.length - 1; i++) {
        let swapped = false;
        for (let j = 0; j < result.length - i - 1; j++) {
          let date1=new Date(result[j].ActualCompletedDate),date2=new Date(result[j + 1].ActualCompletedDate);
          if (
            date1 >
            date2
          ) {
            let temp = result[j + 1];
            result[j + 1] = result[j];
            result[j] = temp;
            swapped = true;
          }
        }
        if (swapped == false) {
          break;
        }
      }
      
      setSortDate('descending')
    }
    else{
      for (let i = 0; i < result.length - 1; i++) {
        let swapped = false;
        for (let j = 0; j < result.length - i - 1; j++) {
          let date1=new Date(result[j].ActualCompletedDate),date2=new Date(result[j + 1].ActualCompletedDate);
          if (
            date1 <
           date2
          ) {
            let temp = result[j + 1];
            result[j + 1] = result[j];
            result[j] = temp;
            swapped = true;
          }
        }
        if (swapped == false) {
          break;
        }
      }
      setSortDate('ascending')
    }
    setSort('')
    setResult(result);
  }
  let timeSort = (type) => {
    if (type == "ascending") {
      for (let i = 0; i < result.length - 1; i++) {
        let swapped = false;
        for (let j = 0; j < result.length - i - 1; j++) {
          if (
            parseFloat(result[j].HoursTracked) >
            parseFloat(result[j + 1].HoursTracked)
          ) {
            let temp = result[j + 1];
            result[j + 1] = result[j];
            result[j] = temp;
            swapped = true;
          }
        }
        if (swapped == false) {
          break;
        }
      }
      setSort('descending')
    }
    else{
      for (let i = 0; i < result.length - 1; i++) {
        let swapped = false;
        for (let j = 0; j < result.length - i - 1; j++) {
          if (
            parseFloat(result[j].HoursTracked) <
            parseFloat(result[j + 1].HoursTracked)
          ) {
            let temp = result[j + 1];
            result[j + 1] = result[j];
            result[j] = temp;
            swapped = true;
          }
        }
        if (swapped == false) {
          break;
        }
      }
      setSort('ascending')
    }
    setSortDate('')
    setResult(result);
  };
  let run = () => {
    let data = result.slice(start, end);
    localStorage.removeItem("search");
    let elt = <div></div>;
    elt = (
      <div id='scroll3' className="w-screen  mt-5 overflow-auto">
        <div id="modalDisplay" className=" w-screen md:w-auto  "></div>
        {localStorage.setItem("search", "")}
           
            <table id='table3'
          className="scale-auto w-[100%] table-fixed md:scale-100  md:table md:w-[95%] md:table-fixed md:m-auto"
          // style={{ width: "95%", tableLayout: "fixed", margin: "auto" }}
        >
          <thead className="font-bold">
            <tr className="bg-gray-200 w-screen overflow-hidden">
              <td className=" md:w-20 py-4 text-center sticky top-auto left-0 z-50 bg-inherit">
                Srl.
              </td>
              <td className=" md:w-60 pl-2 sticky top-0 left-20 z-50 bg-inherit">Deal Name</td>
              <td className="w-44 hidden md:table-cell text-center">Vertical</td>
              <td className="hidden md:table-cell w-[100px] md:w-80 pl-2">
                Deal Description
              </td>
              <td className="md:table-cell md:w-52 pl-3">Task Name</td>
              <td className=" md:w-52 pl-2">Project owner</td>
              <td
                className="hidden md:table-cell md:w-36 cursor-pointer pl-3"
                onClick={() => {
                  timeSort(sort);
                  // console.log(result);
                  setRender(!render)
                }}
              >

                <div className="flex gap-2">
                <div className="">
                Hours Taken</div>
                <div id="asc2" className={`${sort=="ascending"?"":"hidden"}`}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
                            />
                          </svg>
                        </div>
                        <div id="desc2" className={`${sort=="descending"?"":"hidden"}`}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75"
                            />
                          </svg>
                        </div>
                        <div id="both2" className={`${sort?"hidden":""}`}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-4 h-6"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                            />
                          </svg>
                        </div>
                </div>
               
              </td>
              <td className="w-40 text-center cursor-pointer" onClick={()=>{
                dateSort(sortDate)
                setRender(!render)
              }}>
                <div className="flex gap-2">
                <div className="">
                Project Completion</div>
                <div id="asc2" className={`${sortDate=="ascending"?"py-3 pr-4":"hidden"}`}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
                            />
                          </svg>
                        </div>
                        <div id="desc2" className={`${sortDate=="descending"?"py-3 pr-4":"hidden"}`}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75"
                            />
                          </svg>
                        </div>
                        <div id="both2" className={`${sortDate?"hidden":"py-3 pr-4"}`}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-4 h-6"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                            />
                          </svg>
                        </div>
                </div>
              </td>
            </tr>
          </thead>
          <tbody className="">
            {data.map((item, index) => (
              <tr className="even:bg-gray-200 break-words">
                <td className={`idx font-semibold text-center sticky left-0 top-0 z-50 ${index%2!=0?'bg-zinc-200':'bg-white'}`}>
                  {index + start + 1}
                </td>
                <td className={`md:table-cell px-2 sticky2 sticky top-0 left-20 z-50 ${index%2!=0?'bg-zinc-200':'bg-white'}`}>
                  {item.TaskDescription ? (
                    item.TaskDescription.length > lt ? (
                      <button
                        onClick={() => {
                          modalFunction(item.ProjectId);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          className="w-5 h-5 absolute top-1 right-1 text-slate-500 hover:text-slate-700"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </button>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {item.ProjectName}
                </td>
                <td className="hidden md:table-cell text-center overflow-hidden">
                  {item.Vertical}
                </td>
                <td id={`${item.ProjectId}`} className="hidden md:table-cell">
                  <div className="hidden p-1 md:inline-block overflow-x-hidden overflow-y-hidden break-words  max-h-[150px] md:w-[100%] border-none  overflow-auto">
                    {/* {console.log(item.TaskDescription?item.TaskDescription.length:0)} */}
                    {item.TaskDescription
                      ? item.TaskDescription.length < lt
                        ? highlightText(item.TaskDescription)
                        : highlightText(item.TaskDescription.slice(0, lt))
                      : ""}
                    {item.TaskDescription ? (
                      item.TaskDescription.length > lt ? (
                        <a
                          className="text-blue-700 cursor-pointer font-semibold"
                          onClick={() => modalFunction(item.ProjectId)}
                        >
                          ...more
                        </a>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </td>
                <td className="md:table-cell">
                  <div className="md:inline-block overflow-x-hidden overflow-y-hidden p-1 break-words max-h-[150px] md:w-[100%] border-none overflow-auto">
                    {item.TaskName
                      ? item.TaskName.length < lt
                        ? item.TaskName
                        : highlightText(item.TaskName.slice(0, lt))
                      : ""}
                    {item.TaskName ? (
                      item.TaskName.length < lt ? (
                        ""
                      ) : (
                        <a
                          className="text-blue-700 cursor-pointer font-semibold"
                          onClick={() => {
                            modalFunction(item.ProjectId);
                          }}
                        >
                          ...more
                        </a>
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </td>
                <td className="pl-3">{item.ProjectOwner}</td>
                <td
                  className="hidden md:table-cell"
                  style={{ textAlign: "center" }}
                >
                  {item.HoursTracked ? item.HoursTracked.toFixed(2) : ""}
                </td>
                <td className="text-center">{item.ActualCompletedDate?`${item.ActualCompletedDate.split('-')[2]} ${months[Number(item.ActualCompletedDate.split('-')[1])-1]} ${item.ActualCompletedDate.split('-')[0]}`:''}</td>
              </tr>
            ))}
          </tbody>
          <caption className="pb-2">
            Showing{" "}
            <b>
              {start + 1}-
              {start + pageSize > result.length ? result.length : end}
            </b>{" "}
            of <b>{result.length}</b> results
          </caption>
        </table>
        
      </div>
    );
    const root = ReactDOM.createRoot(document.getElementById("SearchTable"));
    root.render(elt);
  };
  useEffect(() => {
    // console.log('running...')
    run();
  }, [render,start]);
  return<div>
  <div id="SearchTable" className="w-screen">SearchTable</div>
  <div className="dv">
          <ReactPaginate
            breakLabel="..."
            nextLabel="Next"
            onPageChange={(e) => {
              // console.log(e.se);
              setStart(e.selected * pageSize);
              setEnd(pageSize * (e.selected + 1));
              setCurrentPage(e.selected);
            }}
            containerClassName="cntnr"
            pageClassName="pg"
            nextClassName={
              currentPage === Math.ceil(allResults.length / pageSize) - 1
                ? "disabled"
                : "nxt"
            }
            breakClassName="brk"
            previousClassName={isFirstPage ? "disabled" : "prv"}
            activeClassName="actv"
            disabledLinkClassName="disabeld"
            pageRangeDisplayed={5}
            pageCount={result.length / pageSize}
            previousLabel="Prev"
            renderOnZeroPageCount={null}
          />
        </div>
  </div>;
}

export default SearchTable;
